import templateUrl from './assign-onboarding-employee-modal.html'

export const AssignOnboardingEmployeeModalComponent = {
    controller: AssignOnboardingEmployeeModalController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    }
}

export const AssignOnboardingEmployeeModal = {
    component: "apexAssignOnboardingEmployeeModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
}

function AssignOnboardingEmployeeModalController() {
    'ngInject'
    const vm = this;

    vm.$onInit = onInit;
    vm.selectedEmployee;
    vm.onCancel = onCancel;
    vm.onAssign = onAssign;

    vm.employeeDropDownOptions = {
        template: "<div><h5 class='h5'>{{ dataItem.FirstName }} {{ dataItem.LastName }}</h5><div class='small'>{{ dataItem.EmailAddress }}</div></div>",
        filter: "contains"
    };

    function onInit() {
        vm.onboardingApplication = vm.resolve.onboardingApplication;
        vm.employees = vm.resolve.employees.map(function (employee) {
            employee.Text = employee.FirstName + " " + employee.LastName;
            return employee;
        });
        vm.assignEmployee = vm.resolve.onAssign;
    }

    function onCancel() {
        vm.dismiss({ $value: "cancel" });
    }

    function onAssign() {
        if (!vm.selectedEmployee) {
            return;
        }
        vm.assignEmployee(vm.selectedEmployee.Id)
            .then(function () {
                vm.close({ $value: vm.selectedEmployee.Id });
            });

    }
}
